import { render } from "./CourseDiscussDetail.vue?vue&type=template&id=3f00b124&scoped=true"
import script from "./CourseDiscussDetail.vue?vue&type=script&lang=js"
export * from "./CourseDiscussDetail.vue?vue&type=script&lang=js"

import "./CourseDiscussDetail.vue?vue&type=style&index=0&id=3f00b124&scoped=true&lang=css"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f00b124"]])

export default __exports__